import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardIcon',
  props: {
    card: { default: '' },
    width: { default: 40 }
  },
  setup(__props: any) {

const props = __props as { card: string, width: number };



const cardTypes: Record<string, string> = {
    visa: require('@/assets/images/visa-colored.svg'),
    unionpay: require('@/assets/images/unionpay-colored.svg'),
    mastercard: require('@/assets/images/master-card-colored.svg'),
    jcb: require('@/assets/images/jcb-colored.svg'),
    discover: require('@/assets/images/discover-colored.svg'),
    dinersclub: require('@/assets/images/diners-club-colored.svg'),
    diners: require('@/assets/images/diners-club-colored.svg'),
    'american express': require('@/assets/images/american-express-colored.svg'),
    amex: require('@/assets/images/american-express-colored.svg')
};

const cardType = computed(() => props.card.toLowerCase());

const svgSrc = computed(() => cardTypes[cardType.value] || require('@/assets/images/generic.svg'));

return { __sfc: true,props, cardTypes, cardType, svgSrc }
}

})